export enum STATUS_POSTULATION {
  PRE_STAGE = 'PRE_STAGE',
  IN_WAITING_LIST = 'IN_WAITING_LIST',
  ENROLLED = 'ENROLLED',
  STUDY_PLAN_CHANGE = 'STUDY_PLAN_CHANGE',
}
